// the Uniswap Default token list lives here
export const DEFAULT_TOKEN_LIST_URL = ''

export const DEFAULT_LIST_OF_LISTS: string[] = [
  //'https://raw.githubusercontent.com/mtvguru/vax-list/main/docs/vax-list.json',
  //'https://mtv.guru/vax-list/vax-list.json',
  //'https://ftm.guru/tokenlists/vax.json',
  'https://ftm1337.eliteness.network/tokenlists/vax.json'
]
